import { Group } from './Group'
import { MaxUsage } from './MaxUsage'
import { Name } from './Name'
import { Utms } from './Utms'

export const CouponFields = {
  MaxUsage,
  Name,
  Utms,
  Group,
}
